import { GsFormSchema } from 'libs/shared/src/components';
import { ACTIVE_SCHEMA_FIELDS } from '../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from '../basics/basic.schema';
import { borderSchemaFields } from './../basics/border.schema';
import { PICTURE_DISPLAY_MODE_SCHEMA } from './../basics/picture-display-mode.schema';
import { ZOOM_SCHEMA_FIELDS } from './../basics/zoom.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the image component form.
 * Defines the fields to display for the form.
 */
export const IMAGE_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...ACTIVE_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'alt',
      groupingName: 'components.image.schema.accessibility',
      label: 'components.image.schema.alternateText',
      type: 'text',
      inputType: 'text',
      placeholder: 'components.image.schema.alternateTextPlaceholder',
      default: ''
    },
    {
      formControlName: 'showFigcaption',
      groupingName: 'components.image.schema.accessibility',
      label: 'components.image.schema.showFigcaption',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'caption',
      groupingName: 'components.image.schema.accessibility',
      label: 'components.image.schema.caption',
      description: 'components.image.schema.captionDescription',
      type: 'text',
      inputType: 'text',
      placeholder: 'components.image.schema.captionPlaceholder',
      default: '',
      if: {
        args: [{ formControlName: 'showFigcaption', value: true }]
      }
    },
    ...ZOOM_SCHEMA_FIELDS,
    {
      formControlName: 'src',
      label: 'components.image.schema.externalImageUrl',
      type: 'text',
      inputType: 'url',
      default: ''
    },
    ...borderSchemaFields(),
    {
      formControlName: 'imageHeight',
      label: 'components.image.schema.imageHeight',
      type: 'number',
      isResponsive: true,
      nullable: true
    },
    ...PICTURE_DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'priority',
      groupingName: 'components.image.schema.performance',
      label: 'components.image.schema.priority',
      description: 'components.image.schema.priorityDescription',
      type: 'checkbox',
      default: false
    }
  ]
};
